// Constantes de conteudo que o time de negocio troca sem mexer em logica.

// Suporte via WhatsApp (link encurtado; o destino e trocado no proprio encurtador).
export const SUPORTE_WHATSAPP_URL = "https://bitlybr.net/suporte-dadospj";

// Videos: so o ID do YouTube (o trecho depois de youtu.be/ ou de watch?v=).

// Dashboard: regras de uso e como a plataforma funciona.
export const VIDEO_REGRAS_DE_USO_ID = "JXWDV_IiAWQ";

// Gerar Lista de Empresas: tutorial rapido de extracao.
export const VIDEO_TUTORIAL_EXTRACAO_ID = "IKdKLgi-e94";
